import { useQuery } from "react-query";
import {
  getFranchiseTypes,
  getCarrierNames,
  getOfficeNames,
  getAcquisitionNames,
  getBrandNames,
  getStates,
  getDistributionChannels,
} from "../../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";

export const useGetFranchiseTypes = () =>
  useQuery(["franchiseTypes"], getFranchiseTypes, {
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

export const useGetCarrierNames = () =>
  useQuery(["carrierNames"], getCarrierNames, {
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

export const useGetOfficeNames = () =>
  useQuery(["officeNames"], getOfficeNames, {
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

export const useGetAcquisitionNames = () =>
  useQuery(["acquisitionNames"], getAcquisitionNames, {
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

export const useGetBrandNames = () =>
  useQuery(["brandNames"], getBrandNames, {
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

export const useGetStates = () =>
  useQuery(["states"], getStates, {
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

export const useGetDistributionChannels = () =>
  useQuery(["channels"], getDistributionChannels, {
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
